import React from 'react'

import { Checkbox, Fieldset } from '@fourthwall/components'

import { isPaidTier } from '../../../../utils'
import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'

export const Discount = () => {
  const { tier, form, isLoading } = useTierContext()

  if (tier && !isPaidTier(tier)) return null

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <Checkbox
          label="Offer a free trial or a discount for new members"
          disabled={isLoading || parseFloat(form.values.price) === 0}
          {...form.getFieldProps(FormFields.discount)}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
